import { put, takeLatest } from "redux-saga/effects";

import { showErrorMessage } from "../../../redux-saga/redux/toast";
import {
  getTopMatchesStart,
  getTopMatchesSuccess,
  getTopMatchesFailure
} from "../../redux/topMatches";
import topMatchesService from "../../services/topMatches";

function* topMatchesWatcher() {
  yield takeLatest(getTopMatchesStart.type, topMatchesWorker);
}

function* topMatchesWorker(action) {
  try {
    const { data, error } = yield topMatchesService.getTopMatches(
      action.payload
    );

    if (data) {
      yield put(
        getTopMatchesSuccess({
          data,
          isHome: action?.payload?.isHome
        })
      );
    }
    if (error) {
      yield put(showErrorMessage({ msg: error }));
      yield put(getTopMatchesFailure());
    }
  } catch (error) {
    yield put(getTopMatchesFailure());
    yield put(showErrorMessage({ msg: error }));
  }
}

export default topMatchesWatcher;
